import { RoleForm } from '@shared/dto/roles.dto'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import axiosClient from '../useAxios'

export const useCreateCompanyRoleMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['companies', 'create-role'],
    mutationFn: async (data: {
      createRoleForm: RoleForm
      companyId: string
    }): Promise<void> => {
      await axiosClient.post(
        `/companies/${data.companyId}/roles`,
        data.createRoleForm
      )
    },
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['companies', variables.companyId, 'roles']
      })
    }
  })
}

export const useDeleteCompanyRoleMutation = (companyId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['companies', 'delete-role'],
    mutationFn: async (data: { roleId: string }): Promise<void> => {
      await axiosClient.delete(`/companies/${companyId}/roles/${data.roleId}`)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['companies', companyId, 'roles']
      })
    }
  })
}

export const useUpdateCompanyRoleMutation = (companyId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['companies', 'update-role'],
    mutationFn: async (data: {
      roleId: string
      updateRoleForm: RoleForm
    }): Promise<void> => {
      await axiosClient.patch(
        `/companies/${companyId}/roles/${data.roleId}`,
        data.updateRoleForm
      )
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['companies', companyId, 'roles']
      })
    }
  })
}
